import React from 'react'

const CardHeadeWithActions = ({children,title , icon , wImage}) => {
    return (
        <div id='Header' className='flex  items-center border-b border-gray-200 p-3 pb-3   '>
            <div  className='flex-1 gap-2 flex flex-row justify-start items-center font-bold text-[#261759]'>
                <img src={icon} alt="" className={` ${wImage ? wImage : 'w-7 h-7'}`}  />
                {title} </div>
            {children}
        </div>
    )   
}

export default CardHeadeWithActions
